import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { chatEndpoints } from '../../services/api/endpoints/chat.endpoint';
import { ChatHistory } from '../../types/chat';
import { logger } from '../../utils/logger';

export const useChatHistory = (connectionId: string) => {
  const [chatHistory, setChatHistory] = useState<ChatHistory[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Use ref to track if initial fetch has been done
  const initialFetchDone = useRef(false);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  useEffect(() => {
    const fetchChatHistory = async () => {
      if (!selectedOrganizationId || !connectionId) return;

      setIsLoading(true);
      setError(null);

      try {
        const data = await chatEndpoints.getChatHistory(selectedOrganizationId, connectionId);
        setChatHistory(data);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to fetch chat history';
        setError(message);
        logger.error('Error fetching chat history:', err);
      } finally {
        setIsLoading(false);
      }
    };

    if (!initialFetchDone.current) {
      fetchChatHistory();
      initialFetchDone.current = true;
    }
  }, [selectedOrganizationId, connectionId]);

  return { chatHistory, isLoading, error };
};
